import { Challenge } from 'data/contracts'
import { isCurrentDateBiggerThanDeadline } from 'sharedKernel/handlers'

export const isChallengeClosed = (challenge: Challenge): boolean => {
  const deadline = challenge.applicationForm?.finalSelectionDate
  if (!deadline) return false
  return isCurrentDateBiggerThanDeadline(deadline)
}
